// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Text, Tooltip } from '@mantine/core';
import { FC } from 'react';
import { IconCircles, IconExternalLink, IconTrashX } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { Resource } from '../../../Types/ResourceT';
import { RoutingS } from '../../../Service/RoutingS';
import LinkText from '../../../Atoms/LinkText';

interface Props {
  resource: Resource;
  quantity?: number | string;
  onDelete?: () => void;
  onClick?: () => void;
}

const ResourceWidgetItem: FC<Props> = ({ resource, quantity, onDelete, onClick }) => {
  const { id, name } = resource;

  const navigate = useNavigate();

  return (
    <Group position="apart">
      <LinkText size="xs" weight="bolder" onClick={onClick ? onClick : () => navigate(`/resources/${id}/details`)}>
        <IconCircles size={16} style={{ marginRight: 5, marginBottom: 3 }} />
        {name}
        {quantity !== undefined && <Text span weight="lighter">{` (${quantity})`}</Text>}
      </LinkText>

      <Group>
        <Tooltip label={'Ressource in neuem Tab öffnen'} withArrow position="right">
          <LinkText size="xs" weight="bolder" onClick={() => RoutingS.openInNewTab(`/resources/${id}/details`)}>
            <IconExternalLink onClick={() => {}} size={16} style={{ marginRight: onDelete ? 5 : 0, marginBottom: 3 }} />
          </LinkText>
        </Tooltip>

        <div>{onDelete && <IconTrashX size={16} cursor="pointer" onClick={onDelete} />}</div>
      </Group>
    </Group>
  );
};

export default ResourceWidgetItem;
